const store = {};
const getItem = (key) => {
  return store[key];
};
const removeItem = (key, paymentMethodIdToRemove) => {
  const updatedPaymentMethodList = store[key].filter(
    (paymentMethodId) => paymentMethodId !== paymentMethodIdToRemove
  );
  store[key] = updatedPaymentMethodList;
};
const setItem = (key, value) => {
  store[key] = value;
};
export {
  getItem,
  removeItem,
  setItem
};
//# sourceMappingURL=alternatePaymentMethodsStorage.js.map
